// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"4390":"d648eb28","9690":"8cc6faea"}[chunkId] || chunkId) + "." + {"4390":"b181e4a5fdb6e97c","5687":"c1c37e80166493f4","9690":"1e9f8a7a1cf54f39"}[chunkId] + ".js";
};